import React, { Component } from 'react';
import FlexItem from './flex_item';

class ArticleFlexLayout extends Component {
  constructor(props) {
    super(props);
  };
  render() {
    const FlexItems = this.props.flexData.map((item, i) =>
      <FlexItem Item={item} key={i + 'blog_post' + this.props.pageId}/>
    );
    return (
      <section id="flexible-layout" className={this.props.hideHero? 'hide-hero flex-layout-blog' : 'flex-layout-blog'}>
        <div id="layout">
          {FlexItems}
        </div>
      </section>
    );
  };
};

export default ArticleFlexLayout;



// WEBPACK FOOTER //
// ./src/pages/blog/blog_single/article_flex_layout.js